import Vue from 'vue';

const resetState = (state) => {
  state.agencyUser = undefined;
  state.agencyUsers = [];
  state.insureSignUsers = [];
  state.products = [];
  state.hawkSoftCloudEnabled = undefined;
  state.agency = undefined;
  state.selectedInsureSignUsers = [];
  state.uniqueInsureSignUsers = [];
  state.registration = {};
  state.error = undefined;
  state.remoteAgencySeats = [];
  state.seatManagementDeletionError = false;
  state.seatManagementDeletionSuccess = false;
  state.seatManagementPendingRequests = [];
  state.featureSwitches = null;
  state.agencyVersion = null;
  state.hasVersion5 = false;
};

const setAgencyUser = (state, agencyUser) => {
  state.agencyUser = agencyUser;
};

const setAgencyUsers = (state, agencyUsers) => {
  agencyUsers.map(x => {
    x.isAdmin = false;
    x.isNewlySelected = true;
  });
  state.agencyUsers = agencyUsers;
};

const setInsureSignUsers = (state, insureSignUsers) => {
  insureSignUsers.sort((a, b) => {
    const aName = a.name.toLowerCase();
    const bName = b.name.toLowerCase();

    if (aName < bName) { return -1; }
    if (aName > bName) { return 1; }

    if (a.initials < b.initials) { return -1; }
    if (a.initials > b.initials) { return 1; }

    return 0;
  });
  insureSignUsers.map(x => {
    x.isNewlySelected = false;
    x.email = x.emailAddress;
  });
  state.insureSignUsers = insureSignUsers;
};

const setProducts = (state, products) => {
  state.products = products;
  var cloudProduct = products.find(({ isHawkSoftCloud }) => isHawkSoftCloud === true);
  if (cloudProduct && cloudProduct.isSubscribed) {
    state.hawkSoftCloudEnabled = true;
  } else {
    state.hawkSoftCloudEnabled = false;
  }
};

const setProductSubscription = (state, { productId, subscription }) => {
  var product = state.products.find(p => p.id === productId);
  product.isSubscribed = subscription;
};

const setProductTrial = (state, { productId, trial }) => {
  var product = state.products.find(p => p.id === productId);
  product.isTrialAvailable = trial;
};

const setDataSharingOptIn = (state, { productId, optInModel }) => {
  var product = state.products.find(p => p.id === productId);
  product.dataSharingOptIn = optInModel;
};

const setAgency = (state, agencyModel) => {
  state.agency = agencyModel;
};

const setSelectedInsureSignUsers = (state, users) => {
  state.selectedInsureSignUsers = users;
  state.uniqueInsureSignUsers = [];
  state.selectedInsureSignUsers.forEach((user) => {
    var userEmail = user.email.toLowerCase();
    if (state.uniqueInsureSignUsers.findIndex(e => e.email === userEmail) < 0) {
      state.uniqueInsureSignUsers.push(user);
    }
  });
  state.uniqueInsureSignUsers.sort((a, b) => {
    if (a.email < b.email) {
      return -1;
    } else {
      return 1;
    }
  });
};

const setRegistration = (state, registrationModel) => {
  state.registration = registrationModel;
};

const setError = (state, error) => {
  state.error = error;
};

const resetError = (state) => {
  state.error = undefined;
};

const setSeatChangeDeletionError = (state, showError) => {
  state.seatManagementDeletionError = showError;
};

const setSeatChangeDeletionSuccess = (state, showSuccess) => {
  state.seatManagementDeletionSuccess = showSuccess;
};

const resetSeatChangeDeletionSuccessState = (state) => {
  state.seatManagementDeletionSuccess = false;
};

const setPendingSeatManagementRequests = (state, pendingRequests) => {
  state.seatManagementPendingRequests = pendingRequests;
};

const addPendingSeatManagementRequest = (state, pendingRequest) => {
  state.seatManagementPendingRequests.push(pendingRequest);
};

const updatePendingSeatManagementRequest = (state, request) => {
  var idx = state.seatManagementPendingRequests.findIndex(x => x.id === request.id);
  if (idx !== -1) {
    Vue.set(state.seatManagementPendingRequests[idx], 'firstName', request.firstName);
    Vue.set(state.seatManagementPendingRequests[idx], 'lastName', request.lastName);
    Vue.set(state.seatManagementPendingRequests[idx], 'email', request.email);
  }
};

const deletePendingSeatManagementRequest = (state, id) => {
  var idx = state.seatManagementPendingRequests.findIndex(x => x.id === id);
  if (idx !== -1) {
    state.seatManagementPendingRequests.splice(idx, 1);
  }
};

const setRemoteAgencySeats = (state, seats) => {
  state.remoteAgencySeats = seats.map(function (seat) { Vue.set(seat, 'display', true); return seat; });
};

const setRemoteAgencySeatDisplay = (state, seat) => {
  var idx = state.remoteAgencySeats.findIndex(x => x.FirstName === seat.FirstName && x.LastName === seat.LastName && x.Email === seat.Email);
  if (idx !== -1) {
    Vue.set(state.remoteAgencySeats[idx], 'display', !state.remoteAgencySeats[idx].display);
  }
};

const addRemoteAgencySeat = (state, seat) => {
  state.remoteAgencySeats.push(seat);
};

const setFeatureSwitches = (state, featureSwitches) => {
  state.featureSwitches = featureSwitches;
};

const setAgencyVersion = (state, version) => {
  state.agencyVersion = version;
  state.hasVersion5 = false;
  if (version != null && version.length > 0) {
    state.hasVersion5 = parseInt(version.substring(0, 1)) >= 5;
  }
};

export default {
  resetState,
  setAgencyUser,
  setAgencyUsers,
  setAgencyVersion,
  setInsureSignUsers,
  setProducts,
  setProductSubscription,
  setProductTrial,
  setDataSharingOptIn,
  setAgency,
  setSelectedInsureSignUsers,
  setRegistration,
  setError,
  resetError,
  setSeatChangeDeletionError,
  setSeatChangeDeletionSuccess,
  resetSeatChangeDeletionSuccessState,
  setPendingSeatManagementRequests,
  addPendingSeatManagementRequest,
  updatePendingSeatManagementRequest,
  deletePendingSeatManagementRequest,
  setRemoteAgencySeats,
  setRemoteAgencySeatDisplay,
  addRemoteAgencySeat,
  setFeatureSwitches
};
